<script lang="ts" setup>
const isOpen = defineModel<boolean>({ required: true })

const { t } = useI18n()
</script>

<template>
  <DTModal v-model="isOpen">
    <DTModalHeader class="!border-b-0" />
    <DTModalBody class="mb-8 space-y-6 !pb-6 !pt-0">
      <h1 class="text-xl font-semibold">
        {{ t('cancellation-policy') }}
      </h1>
      <p class="text-gray-600">
        {{ t('cancellation-policy-modal.text') }}
      </p>
    </DTModalBody>
  </DTModal>
</template>
